import { t } from 'i18next';

import { MenuDivider, MenuHeader, MenuItem } from '@/components/molecules/Menu';
import { OVERVIEW_CAGE_STATUSES, type OverviewCageStatus } from '@/domain/client';

import { breadcrumbCageLabel } from './penStep';
import type { BreadcrumbCage, CagesByStatus } from './types';

export interface CageDropdownItemsProps {
    cagesByStatus: CagesByStatus;
    onCageClick: (cage: BreadcrumbCage) => void;
    /** The pen the reader is on, marked in the list like the current client. */
    selectedCageId?: number;
}

const SECTION_TITLE_KEY: Record<OverviewCageStatus, string> = {
    active: 'common.labels.activeCages',
    inactive: 'common.labels.inactiveCages',
    empty: 'breadCrumb.component.emptyCages',
    historical: 'common.labels.historicalCages',
};

export default function CageDropdownItems(props: CageDropdownItemsProps) {
    const { cagesByStatus, onCageClick, selectedCageId } = props;

    // Historical pens alone are no current choice, so they do not count here.
    if (
        cagesByStatus.active.length === 0 &&
        cagesByStatus.inactive.length === 0 &&
        cagesByStatus.empty.length === 0
    ) {
        return <MenuItem>{t('breadCrumb.component.noCages')}</MenuItem>;
    }

    return (
        <>
            {OVERVIEW_CAGE_STATUSES.map((status, index) => {
                const cages = cagesByStatus[status];
                // The active section always shows, as its header heads the list.
                if (status !== 'active' && cages.length === 0) return null;

                return (
                    <span key={status}>
                        {index > 0 && <MenuDivider />}
                        <MenuHeader>{t(SECTION_TITLE_KEY[status])}</MenuHeader>
                        {cages.map((cage) => (
                            <MenuItem
                                key={`cage_${status}_${cage.id}`}
                                active={cage.id === selectedCageId}
                                onClick={() => onCageClick(cage)}>
                                {breadcrumbCageLabel(cage)}
                            </MenuItem>
                        ))}
                    </span>
                );
            })}
        </>
    );
}
